import { getServiceDetailCopy } from '../i18n/serviceDetailDict';

export const SITE_ORIGIN = 'https://www.sosvor.bongoslcs.com';

export const ORGANIZATION = {
  name: 'SOSVOR',
  legalName: 'SOSVOR — Soluções Integradas',
  url: `${SITE_ORIGIN}/`,
  logo: `${SITE_ORIGIN}/img/sosvor-header-logo.webp`,
  email: 'info.sosvor@bongoslcs.com',
  telephone: '+244927032774',
  addressLocality: 'Luanda',
  addressCountry: 'AO',
  sameAs: [
    'https://www.linkedin.com/company/sosvor1/',
    'https://www.instagram.com/sosvor1',
    'https://www.facebook.com/sosvor',
  ],
};

/** Páginas principais — alinhadas à navegação (Google usa isto para sitelinks). */
export const PRIMARY_NAV = [
  { name: 'Início', path: '/' },
  { name: 'Sobre Nós', path: '/sobre' },
  { name: 'Serviços de Tecnologia', path: '/servicos/tecnologia' },
  { name: 'Carreira', path: '/carreira' },
  { name: 'Notícias', path: '/blog' },
  { name: 'Contacto', path: '/contato' },
  { name: 'Política de Privacidade', path: '/politica-privacidade' },
];

const ROUTE_SEO = {
  pt: {
    '/': {
      title: 'SOSVOR — Tecnologia de Informação, Engenharia e Consultoria em Angola',
      description:
        'Empresa angolana de soluções integradas em tecnologia de informação, cibersegurança, engenharia civil e consultoria. Luanda, Angola.',
    },
    '/sobre': {
      title: 'Sobre a SOSVOR — Quem Somos | Angola',
      description:
        'Conheça a SOSVOR: missão, visão e valores. Referência em tecnologia, engenharia e serviços integrados em Angola.',
    },
    '/blog': {
      title: 'Notícias SOSVOR — Tecnologia e Inovação em Angola',
      description:
        'Novidades, tendências de TI e actualidades da SOSVOR sobre tecnologia de informação e engenharia em Angola.',
    },
    '/carreira': {
      title: 'Carreira SOSVOR — Recrutamento e Vagas em Angola',
      description:
        'Oportunidades de emprego na SOSVOR. Junte-se à equipa de tecnologia, engenharia e consultoria em Luanda, Angola.',
    },
    '/carreira/candidatura-espontanea': {
      title: 'Candidatura Espontânea | Carreira SOSVOR',
      description: 'Envie a sua candidatura espontânea para trabalhar na SOSVOR em Angola.',
    },
    '/contato': {
      title: 'Contacto SOSVOR — Fale Connosco | Luanda, Angola',
      description:
        'Entre em contacto com a SOSVOR. Telefone, email e formulário para projectos de tecnologia e consultoria em Angola.',
    },
    '/politica-privacidade': {
      title: 'Política de Privacidade | SOSVOR',
      description: 'Política de privacidade e utilização de cookies do site SOSVOR.',
    },
    '/termos-servico': {
      title: 'Termos de Serviço | SOSVOR',
      description: 'Termos e condições de utilização dos serviços e do site SOSVOR.',
    },
  },
  en: {
    '/': {
      title: 'SOSVOR — IT, Engineering & Consulting in Angola',
      description:
        'Angolan company delivering integrated IT, cybersecurity, civil engineering and consulting. Luanda, Angola.',
    },
    '/sobre': {
      title: 'About SOSVOR | Angola',
      description: 'Mission, vision and values of SOSVOR — technology and engineering in Angola.',
    },
    '/blog': {
      title: 'SOSVOR News — Technology in Angola',
      description: 'News and insights on IT and innovation from SOSVOR in Angola.',
    },
    '/carreira': {
      title: 'Careers at SOSVOR — Jobs in Angola',
      description: 'Job opportunities at SOSVOR in Luanda, Angola.',
    },
    '/carreira/candidatura-espontanea': {
      title: 'Spontaneous Application | SOSVOR Careers',
      description: 'Submit a spontaneous application to join SOSVOR in Angola.',
    },
    '/contato': {
      title: 'Contact SOSVOR | Luanda, Angola',
      description: 'Get in touch with SOSVOR for IT and consulting projects in Angola.',
    },
    '/politica-privacidade': {
      title: 'Privacy Policy | SOSVOR',
      description: 'SOSVOR website privacy policy and cookie usage.',
    },
    '/termos-servico': {
      title: 'Terms of Service | SOSVOR',
      description: 'Terms and conditions for SOSVOR services and website.',
    },
  },
  fr: {
    '/': {
      title: 'SOSVOR — Technologies, Ingénierie et Conseil en Angola',
      description:
        'Entreprise angolaise en solutions intégrées : informatique, cybersécurité, génie civil et conseil. Luanda, Angola.',
    },
    '/sobre': {
      title: 'À propos de SOSVOR | Angola',
      description: 'Mission, vision et valeurs de SOSVOR en Angola.',
    },
    '/blog': {
      title: 'Actualités SOSVOR — Technologie en Angola',
      description: 'Nouvelles et tendances IT de SOSVOR en Angola.',
    },
    '/carreira': {
      title: 'Carrières SOSVOR — Recrutement en Angola',
      description: 'Opportunités d’emploi chez SOSVOR à Luanda, Angola.',
    },
    '/carreira/candidatura-espontanea': {
      title: 'Candidature spontanée | SOSVOR',
      description: 'Envoyez une candidature spontanée à SOSVOR en Angola.',
    },
    '/contato': {
      title: 'Contact SOSVOR | Luanda, Angola',
      description: 'Contactez SOSVOR pour vos projets IT et conseil en Angola.',
    },
    '/politica-privacidade': {
      title: 'Politique de confidentialité | SOSVOR',
      description: 'Politique de confidentialité et cookies du site SOSVOR.',
    },
    '/termos-servico': {
      title: 'Conditions d’utilisation | SOSVOR',
      description: 'Conditions d’utilisation des services et du site SOSVOR.',
    },
  },
};

function localeKey(locale) {
  if (locale === 'en' || locale === 'fr') return locale;
  return 'pt';
}

export function resolveSeo(pathname, locale = 'pt') {
  const loc = localeKey(locale);
  const routes = ROUTE_SEO[loc] || ROUTE_SEO.pt;

  if (routes[pathname]) {
    return { ...routes[pathname], path: pathname };
  }

  const serviceMatch = pathname.match(/^\/servicos\/([^/]+)$/);
  if (serviceMatch) {
    const slug = serviceMatch[1];
    const copy = getServiceDetailCopy(loc, slug);
    if (copy) {
      const title = `${copy.h1Main} ${copy.h1Highlight}`.replace(/\s+/g, ' ').trim();
      return {
        title: `${title} | SOSVOR Angola`,
        description: copy.description,
        path: pathname,
      };
    }
  }

  const blogMatch = pathname.match(/^\/blog\/([^/]+)$/);
  if (blogMatch) {
    return {
      title: loc === 'en' ? 'Article | SOSVOR News' : loc === 'fr' ? 'Article | SOSVOR' : 'Artigo | Notícias SOSVOR',
      description:
        loc === 'en'
          ? 'Read the latest from SOSVOR on technology in Angola.'
          : loc === 'fr'
            ? 'Lisez la dernière actualité SOSVOR sur la technologie en Angola.'
            : 'Leia a notícia completa da SOSVOR sobre tecnologia e inovação em Angola.',
      path: pathname,
    };
  }

  return {
    title: 'SOSVOR — Soluções Integradas em Angola',
    description: ORGANIZATION.legalName,
    path: pathname,
  };
}

export function buildOrganizationJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${SITE_ORIGIN}/#organization`,
    name: ORGANIZATION.name,
    legalName: ORGANIZATION.legalName,
    url: ORGANIZATION.url,
    logo: ORGANIZATION.logo,
    email: ORGANIZATION.email,
    telephone: ORGANIZATION.telephone,
    address: {
      '@type': 'PostalAddress',
      addressLocality: ORGANIZATION.addressLocality,
      addressCountry: ORGANIZATION.addressCountry,
    },
    sameAs: ORGANIZATION.sameAs,
    areaServed: {
      '@type': 'Country',
      name: 'Angola',
    },
    knowsAbout: [
      'Tecnologia de Informação',
      'Cibersegurança',
      'Engenharia Civil',
      'Consultoria',
      'Transformação Digital',
    ],
  };
}

export function buildWebSiteJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${SITE_ORIGIN}/#website`,
    name: ORGANIZATION.name,
    url: SITE_ORIGIN,
    publisher: { '@id': `${SITE_ORIGIN}/#organization` },
    inLanguage: ['pt-AO', 'pt-BR', 'en', 'fr'],
  };
}

export function buildNavigationJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Navegação principal SOSVOR',
    itemListElement: PRIMARY_NAV.map((item, index) => ({
      '@type': 'SiteNavigationElement',
      position: index + 1,
      name: item.name,
      url: `${SITE_ORIGIN}${item.path === '/' ? '/' : item.path}`,
    })),
  };
}

export function buildBreadcrumbJsonLd(pathname, title) {
  const segments = pathname.split('/').filter(Boolean);
  const items = [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'SOSVOR',
      item: `${SITE_ORIGIN}/`,
    },
  ];

  let acc = '';
  segments.forEach((segment, index) => {
    acc += `/${segment}`;
    items.push({
      '@type': 'ListItem',
      position: index + 2,
      name: index === segments.length - 1 ? title : segment.replace(/-/g, ' '),
      item: `${SITE_ORIGIN}${acc}`,
    });
  });

  if (items.length <= 1) return null;

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items,
  };
}
